const MAX_SEGMENTS = 8;

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const UUID_COMPACT = /^[0-9a-f]{32}$/i;
const DIGITS = /^\d+$/;
const HEX = /^[0-9a-f]+$/i;
const HEX_RUN = /[0-9a-f]{8,}/i;
const LOCALE = /^[a-z]{2}(-[a-z]{2})?$/i;

function isIdentifier(segment: string): boolean {
  if (DIGITS.test(segment) || UUID.test(segment) || UUID_COMPACT.test(segment)) {
    return true;
  }

  if (segment.length >= 12 && HEX.test(segment)) {
    return true;
  }

  if (segment.includes('%')) {
    return true;
  }

  // Build artifacts such as `ffbaf970594b8a09.webpack.hot-update.json` carry a per-build hash.
  if (segment.includes('.') && HEX_RUN.test(segment)) {
    return true;
  }

  // Slugs use hyphens/underscores as word separators; opaque tokens generally do not.
  if (segment.includes('-') || segment.includes('_')) {
    return false;
  }

  if (segment.length > 40) {
    return true;
  }

  if (segment.length < 12) {
    return false;
  }

  // Opaque tokens scatter digits through the string, or alternate case far more often than
  // camelCase route names, where capitals only mark word boundaries.
  const digitCount = (segment.match(/\d/g) ?? []).length;
  const upperCount = (segment.match(/[A-Z]/g) ?? []).length;

  return digitCount >= 3 || upperCount / segment.length >= 0.3;
}

export function normalizeRoutePath(pathname: string): string {
  const segments = pathname.split('?')[0].split('#')[0].split('/').filter(Boolean);

  if (segments.length === 0) {
    return '/';
  }

  const normalized = segments.slice(0, MAX_SEGMENTS).map((segment, index) => {
    if (index === 0 && LOCALE.test(segment)) {
      return ':locale';
    }

    return isIdentifier(segment) ? ':id' : segment.toLowerCase();
  });

  if (segments.length > MAX_SEGMENTS) {
    normalized.push('*');
  }

  return `/${normalized.join('/')}`;
}
